// src/components/GoogleAuth/GoogleAuth.jsx
import { useGoogleLogin } from "@react-oauth/google";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { googleAuth } from "../../../redux/slices/googleSlice";
import google_logo from '../../../assets/svgs/google_logo.svg'
import { REDIRECT_ON_LOGIN } from "../../../lib/constants/routeConstant";
import Loop from '@mui/icons-material/Loop'
import Button from "./Button";
import React from "react";
import { storage } from "../../../config/storage";

const style = `!px-[20px] !py-[10px] font-[400] w-full flex items-center justify-center leading-[19px] gap-2
                  md:!px-[35px] md:!py-[13px] 
`;

const GoogleAuth = ({ googleAuthentication, text="Login with Google" }) => {
  const navigate = useNavigate();
  const { loggingWithGoogle } = useSelector(state => state.googleAuth)

  const login = useGoogleLogin({
    onSuccess: async tokenResponse => {
      const { code } = tokenResponse
      
      const resultAction = await googleAuthentication(code);

      if (googleAuth.fulfilled.match(resultAction)) {
        // check if we have some route to navigate from local-storage
        const defaultNavigation = storage.fetchFromLocalStorage.navigateOnLogin();
        // if we have no route to navigate from local-storage then navigate to default route
        const navigateToRoute = defaultNavigation ? defaultNavigation : REDIRECT_ON_LOGIN;

        navigate(navigateToRoute); // Navigate to the appropriate page
        
        // now clear from local storage
        storage.destroyFromLocalStorage.navigateOnLogin();
      }
    },
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/user.phonenumbers.read',
  });

  return (
    <Button variant="secondary" onClick={login} className={style} disabled={loggingWithGoogle}>
      {loggingWithGoogle ? `Logging in...` : text}
      {loggingWithGoogle ? (
        <Loop className="animate-spin" />
      ): (
        <img src={google_logo} alt="Google Logo" className="w-5 h-5" />
      )}
    </Button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  googleAuthentication: (data) => dispatch(googleAuth(data)),
});

export default connect(null, mapDispatchToProps)(React.memo(GoogleAuth));
